module.exports = __webpack_public_path__ + "img/t2.248e497c.png";